import { fetchExtensions } from '@/vuex/modules/integrations/integrations.utils';

const integrations = {
    namespaced: true,
    state: {
        installedIntegrations: [],
    },
    mutations: {
        setInstalledIntegrations (state, { installedIntegrations }) {
            const seen = new Set();
            state.installedIntegrations = (installedIntegrations || []).filter((integration) => {
                const providerName = integration.provider ? integration.provider.name : '';
                const key = `${integration.environment || ''}::${providerName}::${integration.name || ''}`;
                if (seen.has(key)) return false;
                seen.add(key);

                return true;
            });
        },
    },
    actions: {
        async getInstalledIntegrations ({ commit }) {
            const installedIntegrations = await fetchExtensions();

            commit('setInstalledIntegrations', { installedIntegrations });
        },
    },
};

export default integrations;
